import React, { forwardRef } from "react";
import classNames from "classnames";
import Option, { Options } from "./Option";
import Validation from "./Validation";

const Select = forwardRef(
  (
    {
      id,
      name,
      className,
      children,
      required,
      placeholder,
      ariaDescribedby,
      ariaLabelledby,
      ariaLabel,
      list,
      multiple,
      title,
      size,
      disabled,
      value,
      defaultValue,
      isValid, // optional, but not used for per-field state here
      isTouched, // component prop
      invalidFeedback, // component prop (error message)
      validFeedback,
      isValidMessage = true,
      isTooltipFeedback,
      onBlur,
      onChange,
      onFocus,
      onInput,
      onInvalid,
      onSelect,
      // backward-compatible props commonly used with Formik:
      error,   // formik.errors.status
      touched, // formik.touched.status
      ...props
    },
    ref
  ) => {
    // prefer explicit component props; fall back to "error" / "touched" names
    const touchedLocal = typeof isTouched !== "undefined" ? isTouched : touched;
    const invalidFeedbackLocal = invalidFeedback || error;

    const showError = !!touchedLocal && !!invalidFeedbackLocal;
    const showValid = !!touchedLocal && !invalidFeedbackLocal;

    return (
      <>
        <select
          ref={ref}
          id={id}
          className={classNames(
            "form-select",
            {
              [`form-select-${size}`]: size,
              "text-muted": value === "" && placeholder,
              "is-invalid": showError,
              "is-valid": showValid,
            },
            className
          )}
          name={name}
          aria-label={ariaLabel}
          aria-describedby={ariaDescribedby}
          aria-labelledby={ariaLabelledby}
          multiple={multiple}
          disabled={disabled}
          title={title}
          value={value}
          defaultValue={defaultValue}
          required={required}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          onInput={onInput}
          onInvalid={onInvalid}
          onSelect={onSelect}
          {...props}
        >
          {placeholder && (
            <Option value="" disabled hidden>
              {placeholder}
            </Option>
          )}
          {children || (list && <Options list={list} />)}
        </select>

        {isValidMessage && (
          <Validation
            isTouched={touchedLocal}
            invalidFeedback={invalidFeedbackLocal}
            validFeedback={validFeedback}
            isTooltip={isTooltipFeedback}
          />
        )}
      </>
    );
  }
);

export default Select;
